import React from "react";
import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import creationData from './CreationSolution.json'
import responsibilityData from './ResponsibilitySolution.json'

const FeatureTextArea = styled((props) => (
    <Box component="section" {...props}>
        <span className="display-medium h2">{props.title}</span>
        <span className="headline-large neutrals" style={{paddingTop: "1rem"}}>{props.desc}</span>
    </Box>
))(({ theme, id }) => ({
    position: "relative",
    [theme.breakpoints.up("md")]: {
    },
}));

const FeatureDemo = styled((props) => (
    <Box component="section" {...props}>
        <FeatureTextArea title={props.title} desc={props.desc} id={props.id} style={{paddingTop: "4rem"}}/>
         <img src={props.image} style={{width: "100%",  objectFit: "cover", marginTop: "2rem"}} />
    </Box>
))(({ theme, direction }) => ({
}));

function Solution() {
    return(
        <div style={{position: "relative", width: "70vw", marginLeft: "auto", marginRight: "auto", marginTop: "10rem", marginBottom: "20vh"}}>
            
            <span className='display-large h1' >
               My Scope at TikTok Team
            </span>
            <span className='headline-large neutrals' style={{marginTop: "1rem"}} >
            As part of the Creation team, I focused on building intuitive, powerful tools that empower creators to express themselves more creatively. From enhancing storytelling capabilities to enabling new formats of self-expression, our goal was to make content creation not only easier, but also more imaginative and fun.
            </span>
            {creationData.map((props, idx) => (
                    <FeatureDemo idx={idx} {...props} />
            ))}

            <span className='display-large h1' style={{paddingTop: "8rem"}} >
               My Scope at Responsibility Team
            </span>
            <span className='headline-large neutrals' style={{marginTop: "1rem"}} >
            As a product designer on TikTok’s Responsibility Team, I focus on teen safety, accessibility, and Family Pairing Mode. I design and optimize features that protect young users, enhance accessibility for all, and empower families to manage TikTok together. My work helps create a safer, more inclusive, and positive content environment for the TikTok community.
            </span>
            {responsibilityData.map((props, idx) => (
                   <FeatureDemo idx={idx} {...props} />
            ))}
        </div>
        
    )
}

export default Solution;
